import React from "react";
import SummaryCardLayout from "./SummaryCardLayout";
import { getFullName } from "../../../../Modules/utils/fullname";
import { RenderDenomination } from "../../../../Components/etc/RenderAmount";

export default function FinalSummaryBalanceAdjustment(props) {
  const { data } = props;
  const total = Number(data.totalAmount || 0);

  const INR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

  const renderPreviewContent = (d) => (
    <div className="p-0">
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>Balance due adjusted for</td>
            <td className="text-end fw-bold">{getFullName(d.agent)}</td>
          </tr>
        </tbody>
      </table>

      <div className="fw-semibold small mt-3">Amount Summary</div>
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td className="fw-bold">Total Amount</td>
            <td className="text-end fw-bold">{INR(total)}</td>
          </tr>
        </tbody>
      </table>

      {d.note && (
        <>
          <div className="fw-semibold small mt-2">Note</div>
          <div className="border rounded p-2 small">{d.note}</div>
        </>
      )}
    </div>
  );

  // ----------------------------------------------------
  // Printable summary
  // ----------------------------------------------------
  const renderPrintableContent = (d) => (
    <div className="p-0">
      <h6 className="fw-bold mb-2">User Balamce Due Adjustment</h6>

      <table className="table table-borderless table-sm mb-3">
        <tbody>
          <tr>
            <td>Field Executive</td>
            <td className="text-end fw-bold">{getFullName(d.relatedUser)}</td>
          </tr>

          <tr>
            <td className="fw-bold">Total Adjusted Amount</td>
            <td className="text-end fw-bold">{INR(total)}</td>
          </tr>
        </tbody>
      </table>

      <h6 className="fw-bold mt-3">Total Balance</h6>
      <table className="table table-sm mb-2">
        <tbody>
          <tr>
            <td>User Balance Due After Adjustment</td>
            <td className="text-end fw-bold">
              {INR(Number(data.userBalanceDue?.total))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  // ----------------------------------------------------
  // Determine mode
  // ----------------------------------------------------
  let mode = "preview";
  if (props.mode === "details") mode = "details";
  else if (data?.transaction?._id) mode = "submitted";

  // ----------------------------------------------------
  // Render using SummaryCardLayout wrapper
  // ----------------------------------------------------
  return (
    <SummaryCardLayout
      mode={mode}
      data={data}
      renderPreviewContent={renderPreviewContent}
      renderPrintableContent={renderPrintableContent}
      onBack={() => props.onSubmit({ step: data.step - 1 })}
      onSubmit={props.onFinalSubmit}
      onClose={props.handleClose}
      onEdit={props.handleEdit}
      onDelete={props.handleDelete}
      onApprove={props.handleApprove}
    />
  );
}
